module.exports = __webpack_public_path__ + "img/logo.31efd11f.png";